import { z } from 'zod';
import { brandGradientSchema, hexColorSchema } from '@glomopay/utils';

// Empty string is the documented "no tenant colour, fall back to Glomo's own
// --brand-primary" sentinel (see DEFAULT_BRANDING), so it stays valid here. The
// design-system config in @glomopay/theme has no such sentinel and requires a real
// hex — the two seeds differ on purpose; only the hex primitive is shared.
const brandSeedColor = z.union([hexColorSchema, z.literal('')]);

const tenantBrandingThemeSchema = z.object({
  primaryColor: brandSeedColor.optional(),
  backgroundColor: z.string().optional(),
  ringColor: z.string().optional(),
  brandGradient: brandGradientSchema.nullish(),
});

const tenantBrandingSchema = z.object({
  theme: tenantBrandingThemeSchema.optional(),
  logoText: z.string().url().nullable().optional(),
  logoSymbol: z.string().url().nullable().optional(),
  favicon: z.string().url().nullable().optional(),
  backgroundImage: z.string().url().nullable().optional(),
  appName: z.string().optional(),
  supportEmail: z.string().optional(),
  fontFamily: z.string().nullable().optional(),
  fontsCssUrl: z.string().url().nullable().optional(),
  headingFontWeight: z.string().optional(),
  poweredByVisible: z.boolean().optional(),
  showOnlyHeaderLogo: z.boolean().optional(),
});

export const tenantConfigSchema = z.object({
  isWhitelabel: z.boolean(),
  authMode: z.enum(['cookie', 'bearer_token']),
  selfServeOnboardingEnabled: z.boolean().optional().default(false),
  branding: tenantBrandingSchema.optional(),
});

export type TTenantConfigResponse = z.infer<typeof tenantConfigSchema>;
